import { c as _c } from "react/compiler-runtime";
import { useRouter } from "next/router";
import { RefObject, useEffect, useRef } from "react";
interface Properties {
  scroll?: boolean;
  containerReference: RefObject<HTMLDivElement | null>;
  filterKeys: Array<string>;
}
export function useHandleScroll(t0) {
  const $ = _c(7);
  const {
    scroll: t1,
    containerReference,
    filterKeys
  } = t0;
  const scroll = t1 === undefined ? true : t1;
  const router = useRouter();
  const previousQuery = useRef(router.query);
  let t2;
  if ($[0] !== containerReference || $[1] !== filterKeys || $[2] !== router.query || $[3] !== scroll) {
    t2 = () => {
      if (scroll && containerReference.current) {
        if (filterKeys.some(key => previousQuery.current[key] !== router.query[key])) {
          const top = window.scrollY + containerReference.current?.getBoundingClientRect().top - 80;
          if (window.scrollY >= top) {
            window.scroll({
              top,
              behavior: "instant"
            });
          }
        }
        previousQuery.current = router.query;
      }
    };
    $[0] = containerReference;
    $[1] = filterKeys;
    $[2] = router.query;
    $[3] = scroll;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== router.query) {
    t3 = [router.query];
    $[5] = router.query;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  useEffect(t2, t3);
}